import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpotify = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M0 8a8.01 8.01 0 0 1 8-8 8.01 8.01 0 0 1 8 8 8.01 8.01 0 0 1-8 8 8.01 8.01 0 0 1-8-8zm1.285 0c0 3.703 3.013 6.716 6.716 6.716S14.716 11.703 14.716 8 11.703 1.284 8 1.284 1.285 4.297 1.285 8zm11.003-2.371c-3.34-1.544-8.032-.859-8.23-.829a.64.64 0 0 0-.539.731c.053.351.38.593.731.539.045-.007 4.512-.656 7.499.725a.64.64 0 0 0 .269.059c.243 0 .475-.138.583-.373a.64.64 0 0 0-.314-.852zM4.341 7.294c.179-.027 4.42-.646 7.444.751.322.149.462.531.314.852-.108.235-.341.373-.583.373a.64.64 0 0 1-.269-.059c-2.671-1.234-6.673-.653-6.713-.647-.351.053-.678-.189-.731-.54a.64.64 0 0 1 .539-.731zm.149 2.401c.157-.024 3.884-.568 6.547.663.322.149.462.531.314.852a.64.64 0 0 1-.852.314c-2.317-1.071-5.781-.564-5.816-.558-.351.053-.678-.188-.731-.539a.64.64 0 0 1 .539-.731z",
			fill: "#333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgSpotify;
